// extracted by mini-css-extract-plugin
export default {"headerTitleText":"BfU4bJ","headerPriorTitleText":"ugp9VG","scrollTarget":"uxbFt7"};